<script lang="ts" type="module">
    import { i18n } from "../store"

    export let titel: string
    export let text: string
    export let bild: string
    export let url: string
</script>

<!-- Listview -->
<div class="post">
    <div class="item">
        <div class="image">
            <a href="{url}"><img src="{bild}" alt="" /></a>
            <div class="headline">
                <h3><a href="{url}">{titel}</a></h3>
            </div>
        </div>
        <div class="text">
            <p>{text}</p>
            <a href="{url}" class="btn">{$i18n("mehr")}</a>
        </div>
    </div>
</div>

<style lang="less">
    @import "../css/base.less";

    // List
    .post {
        width: 33.3333333%;
        @media (max-width: 1000px) {
            width: 50%;
        }
        @media (max-width: 700px) {
            width: 100%;
            // max-width: 300px;
            // margin: 0 auto;
        }
    }
    .item {
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .transition();
        .image {
            width: 100%;
            height: auto;
            position: relative;
            overflow: hidden;
            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                .transition();
            }
            .headline {
                position: absolute;
                background: #fff;
                bottom: 0;
                left: 0;
                width: auto;
                height: auto;
                padding: 10px 20px;
                margin: 0px;
                h3 {
                    font-size: 1.1rem;
                    margin: 0px;
                    color: @textcolor;
                    a {
                        color: @textcolor;
                        .transition();
                    }
                }
            }
        }
        .text {
            padding: 20px;
        }
        &:hover {
            -webkit-box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            img {
                transform: scale(1.1);
            }
            .image .headline h3 > a {
                color: @maincolor;
            }
        }
    }
</style>
